var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"payType",style:({border:(_vm.selected == true?'#ed6c00 solid 1px':'none')})},[_c('img',{attrs:{"src":_vm.imagePath,"width":_vm.imgWidth,"height":"30px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }